import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  BenefitActivityLogItemType,
  BenefitActivityLogPagination,
  BenefitActivityLogQueryType,
} from "./Types";

type BenefitsLogStateType = {
  logs: BenefitActivityLogItemType[];
  pagination: BenefitActivityLogPagination;
  lastQuery: { partnerId: number; query: BenefitActivityLogQueryType } | null;
  status: {
    loading: boolean;
    saving: boolean;
    errorMessage: string;
  };
};

const initialPagination: BenefitActivityLogPagination = {
  currentPage: 1,
  perPage: 20,
  totalRecords: 0,
};

const initialState: BenefitsLogStateType = {
  logs: [],
  pagination: initialPagination,
  lastQuery: null,
  status: {
    loading: false,
    saving: false,
    errorMessage: "",
  },
};

const benefitsLogSlice = createSlice({
  name: "partner_program_benefits_log",
  initialState,
  reducers: {
    setBenefitsLogLoading: (state, action: PayloadAction<boolean>) => {
      state.status.loading = action.payload;
    },
    setBenefitsLogSaving: (state, action: PayloadAction<boolean>) => {
      state.status.saving = action.payload;
    },
    setBenefitsLogErrorMessage: (state, action: PayloadAction<string>) => {
      state.status.errorMessage = action.payload;
    },
    setBenefitsLogList: (
      state,
      action: PayloadAction<BenefitActivityLogItemType[]>
    ) => {
      state.logs = action.payload;
    },
    setBenefitsLogPagination: (
      state,
      action: PayloadAction<BenefitActivityLogPagination>
    ) => {
      state.pagination = action.payload;
    },
    setBenefitsLogLastQuery: (
      state,
      action: PayloadAction<BenefitsLogStateType["lastQuery"]>
    ) => {
      state.lastQuery = action.payload;
    },
    clearBenefitsLogList: (state) => {
      state.logs = [];
      state.pagination = initialPagination;
      state.lastQuery = null;
      state.status.errorMessage = "";
    },
  },
});

export const benefitsLogSliceReducer = benefitsLogSlice.reducer;
export const benefitsLogSliceAction = benefitsLogSlice.actions;
